import { Injectable } from '@angular/core';
import { TournamentApiService } from '@fantaz/shared/data-access/api';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import * as LeaderBoardActions from './leader-board.actions';

@Injectable()
export class LeaderBoardEffects {
  init$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LeaderBoardActions.loadLeaderBoard),
        switchMap((payload) => {
          return this.tournamentApiService.getLeadership(payload).pipe(
            map((data) => {
              return LeaderBoardActions.loadLeaderBoardSuccess({
                leaderBoard: data.leaders,
                total: data.total,
              });
            }),
            catchError((error) => {
              return of(LeaderBoardActions.loadLeaderBoardFailure({ error }));
            }),
          );
        }),
      ),
    { dispatch: true },
  );

  constructor(
    private readonly actions$: Actions,
    private tournamentApiService: TournamentApiService,
  ) {}
}
